import { render } from "./AdminSellers.vue?vue&type=template&id=c23606dc"
import script from "./AdminSellers.vue?vue&type=script&lang=js"
export * from "./AdminSellers.vue?vue&type=script&lang=js"

import "./AdminSellers.vue?vue&type=style&index=0&id=c23606dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__